export default __webpack_public_path__ + "static/media/promo-muggle-murders-rise_04.a68a6e3e.jpg";